import React from 'react';

export default function AuraLogo({ size = 32 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      style={{ flexShrink: 0, display: 'block' }}
    >
      <rect width="64" height="64" rx="14" fill="#1a73e8" />
      <rect x="18" y="20" width="28" height="3" rx="1.5" fill="#fff" />
      <line x1="46" y1="21.5" x2="50" y2="28" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="50" cy="29" r="1.5" fill="#fff" />
      <path d="M32 14 L46 20 L32 26 L18 20 Z" fill="#fff" />
      <text x="32" y="50" fontFamily="Arial,Helvetica,sans-serif" fontSize="22" fontWeight="900" fill="#fff" textAnchor="middle">A</text>
    </svg>
  );
}
